import { createComponent } from '@carvana/merch-components';
import styled from 'styled-components';
import Close from '~/icons/Close';

export const ErrorText = createComponent('p', {
  className: 'mt-20 text-center text-red-2 tl-body-s m:tl-body-m'
});

export const Icon = styled.img.attrs({
  className: 'h-auto inline-block mr-8'
})`
  width: 20px;
`;

export const Bold = createComponent('span', {
  className: 'font-bold'
});

export const CloseIcon = styled(Close)`
  && {
    position: absolute;
    top: 10px;
    right: 10px;
    color: var(--cvna-color-white);
    fill: var(--cvna-color-white);
    cursor: pointer;
  }
`;

export const CenteredContainer = styled.div.attrs({
  className: 'text-center'
})`
  header {
    text-align: center;
  }
`;
